import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Modal from 'react-awesome-modal';
import _ from 'lodash';

import ModalHeader from '../../../shared/modal-header/components/modal-header';
import Button from '../../../shared/button/components/button';
import { toggleRegisterTypeModal } from '../actions/register-actions';
import registerConstants from '../constants/register-constants';
import constants from '../../../../common/constants';
import Helpers from '../../../../common/helpers';

import '../styles/register-type-modal.css';
import nagaLogo from '../../../../common/images/naga-logo.png';

class RegisterTypeModal extends Component {
  state = {
    user_type: registerConstants.user_types.affiliate,
  };

  closeModal() {
    const { toggleRegisterTypeModal } = this.props;

    toggleRegisterTypeModal(false);
  }

  onChangeUserType = value => {
    this.setState({ user_type: value });
  };

  handleButtonClick(user_type) {
    localStorage.removeItem(constants.user_register_key_word);
    localStorage.setItem(
      constants.user_register_key_word,
      JSON.stringify({
        user_type,
      })
    );

    Helpers.goToPage(`/register/1?user_type=${user_type}`);
  }

  renderUserTypeLevelOptions = userTypes => {
    const { t } = this.context;
    const { user_type } = this.state;

    return userTypes.map(item => {
      return (
        <div key={item.value} className={`user-type-level-option-item ${item.value === user_type ? 'selected' : ''}`} onClick={() => this.onChangeUserType(item.value)}>
          <p className="user-type-level-option-item__title"> {t(item.pre_label)} </p>
          <p className="user-type-level-option-item__description"> {t(item.label)} </p>
        </div>
      );
    });
  };

  render() {
    const { showRegisterTypeModal } = this.props;
    const { user_type } = this.state;
    const userTypes = _.filter(registerConstants.user_type_options, type => {
      return !type.hidden;
    });

    return (
      <Modal visible={showRegisterTypeModal} className="register-type-modal" effect="fadeInUp">
        <div className="register-type-modal-container">
          <ModalHeader title={'REGISTER.SELECT_YOUR_ACCOUNT_TYPE'} icon={nagaLogo} onClick={() => this.closeModal()} hideCloseBtn />
          <div className="col-md-12">{this.renderUserTypeLevelOptions(userTypes)}</div>
          <div className="col-md-12">
            <Button label={'COMMON.CONTINUE'} disabled={!user_type} customClass={'affiliate-btn-blue m-t-20 m-b-20'} onClick={() => this.handleButtonClick(user_type)} />
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  showRegisterTypeModal: state.registerReducer.showRegisterTypeModal,
});

const mapDispatchToProps = dispatch => ({
  toggleRegisterTypeModal: show => {
    dispatch(toggleRegisterTypeModal(show));
  },
});

RegisterTypeModal.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(RegisterTypeModal);



// WEBPACK FOOTER //
// ./src/app/main/register/components/register-type-modal.js